export function transformToBackendEventRowData(data: any) { // eslint-disable-line
  return {
    id: data.id,
    datamodel_type: data.datamodel_type,
    row_data: data.row_data,
  };
}

export function transformFromBackendDatamodelRowData(backendType: any) { // eslint-disable-line
  return {...backendType, id: backendType.sygno_id};
}
